import TemplateModel from "../../Loyalty/Models/Template/TemplateModel";

export default class PastTemplateModel {
  public id: string = null;
  public name: string = null;
  public model: TemplateModel = new TemplateModel();
}
